"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEllipsisActive = void 0;
const isEllipsisActive = element => {
  const tolerance = 2; // Tolerance in px to cover different font size usage
  if (element === null) {
    return false;
  }

  // Check for ellipsis due to line clamping (height check)
  const isHeightClamped = element.offsetHeight + tolerance < element.scrollHeight;

  // Check for ellipsis due to overflow (width check)
  const isWidthClamped = element.offsetWidth < element.scrollWidth;
  return isHeightClamped || isWidthClamped;
};
exports.isEllipsisActive = isEllipsisActive;
//# sourceMappingURL=isEllipsisActive.js.map